import {Grid, makeStyles, Typography} from "@material-ui/core";
import React from "react";
import {reviewStyle} from "../../../../UIComponent/CommonStyle";

const useStyles = makeStyles((theme) => ({
    ...reviewStyle(theme),
}));

export default function SummaryItem({title, dbValue, updatedValue}) {
    const classes = useStyles();

    return (
        <>
            <Grid item xs={2}>
                <Typography className={classes.subtitle}>{title}:</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography
                    className={classes.subtitle}>{dbValue} → {updatedValue}</Typography>
            </Grid>
        </>
    )
}
